<template >
  <v-layout>
    <v-panel
      contextual-style="primary"
    >
      <!-- <h1 class="panel-title" slot="heading" style="vertical-alignment: middle; padding-top: 10px; padding-bottom: 10px;">
        Edit List: {{ $store.state.lists.thislist.name }}{{ $store.state.lists.thislist.description ? ' ('+$store.state.lists.thislist.description+')' : '' }}
        <button type="button" class="btn btn-sm btn-default" style="float: right" data-toggle="modal" data-target="#bulkModal">Bulk import</button>
        <button type="button" class="btn btn-sm btn-info" style="float: right" data-toggle="modal" data-target="#addModal">Add Entry</button>
      </h1> -->
      <div slot="body">

        <nav class="navbar navbar-default">
        <div class="container-fluid">

          <div class="navbar-header">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" hhref="">Edit List: {{ $store.state.lists.thislist.name }}{{ $store.state.lists.thislist.description ? ' ('+$store.state.lists.thislist.description+')' : '' }}</a>
          </div>

        <!-- Collect the nav links, forms, and other content for toggling -->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
          <!-- <ul class="nav navbar-nav">
            <li class="active"><a href="#">Domains<span class="sr-only"> (current)</span></a></li>
            <li><a href="#">URLs</a></li>
          </ul> -->
          <ul class="nav navbar-nav navbar-right">
            <li><button type="button" class="btn btn-default navbar-btn" @click="BulkExport()">Bulk Export</button></li>
            <li>&nbsp;</li>
            <li><button type="button" class="btn btn-warning navbar-btn" data-toggle="modal" data-target="#bulkModal">Bulk Actions</button></li>
            <li>&nbsp;</li>
            <li><button type="button" class="btn btn-info navbar-btn" data-toggle="modal" data-target="#addModal">Add Entry</button></li>
          </ul>
        </div><!-- /.navbar-collapse -->
      </div>
      </nav>


      <div class="modal fade" id="bulkModal" role="dialog">
        <div class="modal-dialog">

          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">Bulk List Actions</h4>
            </div>
            <div class="modal-body">
              <textarea v-model="bulkurls" id="textarea_bulk_import"  name="bulkurls" cols="78" rows="20" placeholder="Paste a list of Domains/URLs here, one per line.

NB: Any https URLs will be blocked as full domains.">
              </textarea>
            </div>
            <div v-if="errBulkmsg" class="modal-footer">
              <span style="color: red; float: left">ERROR: {{ errBulkmsg }}</span>
            </div>
            <div class="modal-footer">
              <button v-if="!bulkprocessing" type="button" class="btn btn-info" ddata-dismiss="modal" @click="BulkProcess('add')">Add Items</button>
              <button v-if="!bulkprocessing" type="button" class="btn" ddata-dismiss="modal" @click="BulkProcess('replace')">Replace All</button>
              <button v-if="!bulkprocessing" type="button" class="btn" ddata-dismiss="modal" @click="BulkProcess('delete')">Delete Items</button>
              <button v-if="!bulkprocessing" type="button" class="btn btn-warning" data-dismiss="modal" @click="BulkCancel()">Cancel</button>
              <button v-if="bulkprocessing" type="button" class="btn" data-dismiss="modal" @click="BulkCancel()">Please wait...</button>
            </div>
          </div>

        </div>
      </div>

      <div class="modal fade" id="addModal" role="dialog" :class="{ in: addModalShown }">
        <div class="modal-dialog">

          <!-- Modal content-->
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal">&times;</button>
              <h4 class="modal-title">Single URL Import</h4>
            </div>
            <div class="modal-body">
              <div class="input-group">
                <span class="input-group-addon">@</span>
                <input v-on:keyup.enter="ImportOneURL()" v-model="oneurl" id="oneurl" type="text" class="form-control" placeholder="https://xyz.com/abc">
              </div>
            </div>
            <div class="modal-footer">
              <span v-if="errOnemsg" style="color: red; float: left">ERROR: {{ errOnemsg }}</span>
              <button type="button" class="btn btn-info" ddata-dismiss="modal" @click="ImportOneURL()">Import</button>
              <button type="button" class="btn btn-warning" data-dismiss="modal">Cancel</button>
            </div>
          </div>

        </div>
      </div>


        <table class="table">
          <thead>
            <tr>
              <th>Protocol</th>
              <th>Domain</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(thisentry, thisindex) in $store.state.lists.listentries" v-bind:class="{ 'highlightentry': highlight_id == thisentry.url_id }">
              <td align="left" style="vertical-align: middle;; padding: 4px" class="col-sm-3">
                <span v-if="thisentry.path == '/' || thisentry.path == ''">http:// + https://</span>
                <span v-if="thisentry.path != '/' && thisentry.path != ''">http://</span>
                <span v-if="rerenderCount"></span>
              </td>
              <td v-if="editing[thisindex]" class="col-sm-6" style="vertical-align: middle; padding: 4px">
                <form role="form" autocomplete="off" @submit.prevent="onSubmit(thisentry)">
                    <input v-ref="'domain' + thisindex" v-bind:value="thisentry.domain" class="form-control" name="fields" type="text" placeholder="eg: domain.com" />
                </form>
              </td>
              <td v-if="!editing[thisindex]" class="col-sm-6" style="vertical-align: middle; padding: 4px">
                {{ thisentry.domain }}{{ thisentry.path }}&nbsp;<span v-if="false" class="badge badge-warning">Domain</span>
              </td>
              <td vv-if="!thisentry.tmp_editing" class="col-sm-3" style="padding: 4px">
                <button v-if="editing[thisindex]" @click="clickokdomain(thisindex, thisentry)" type="button" class="btn btn-default btn-xs btn-edit">OK</button>
                <button v-if="editing[thisindex]" @click="clickcanceldomain(thisindex)" type="button" class="btn btn-default btn-xs btn-delete">Cancel</button>
                <button v-if="false && !editing[thisindex]" @click="clickeditdomain(thisindex)" type="button" class="btn btn-default btn-xs btn-edit">Edit</button>
                <button v-if="!editing[thisindex]" @click="clickdeletedomain(thisentry)" type="button" class="btn btn-default btn-xs btn-delete">Delete</button>
              </td>
            </tr>
          </tbody>
          <tfoot>
             <td>
             </td>
          </tfoot>
        </table>

        <div align="center" style="margin: 0px; padding: 0px;">
        <nav aria-label="Page navigation">
          <ul class="pagination" style="margin: 4px;">
            <li v-bind:class="{ 'disabled': ($store.state.lists.listentries_pageinfo.thispage_number == 1) }">
              <a v-on:click.prevent="setPage(page-pageSkip)" href="#" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
              </a>
            </li>
            <li v-bind:class="{ 'active': (pageentry == $store.state.lists.listentries_pageinfo.thispage_number) }" v-on:click.prevent="setPage(pageentry)" v-for="(pageentry, pageindex) in $store.state.lists.listentries_pageinfo.display_pagelist"><a href="#">{{ pageentry }}</a></li>
            <li v-bind:class="{ 'disabled': ($store.state.lists.listentries_pageinfo.thispage_number >= $store.state.lists.listentries_pageinfo.total_pages) }">
              <a v-on:click.prevent="setPage(page+pageSkip)" href="#" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>


      </div>
    </v-panel>
  </v-layout>
</template>
<script>
/* global $ */

import listService from '../../../services/list';
// import route from '../../../routes';
import store from './../../../store';
import Vue from 'vue';

export default {
  data() {
    return {
      addModalShown: false,
      formdata: {
      },
      errOnemsg: '',
      errBulkmsg: '',
      errmsg: '',
      bulkurls: '',
      oneurl: '',
      page: 1,
      pageSize: 10,
      pageSkip: 10,
      rerenderCount: 0,
      editing: [],
      bulkprocessing: false,
      one_off_listoffset: 0,
      highlight_id: '',
    };
  },
  methods: {
    onSubmit() {
      // console.log(data);
      // listService.getlist($route.params.listid);
    },
    setPage(pagenum) {
      this.page = pagenum;
      if (this.page > store.state.lists.listentries_pageinfo.total_pages) {
        this.page = store.state.lists.listentries_pageinfo.total_pages;
      }
      if (this.page <= 0) {
        this.page = 1;
      }
      // console.log(this.page);
      // console.log(store.state.lists.listentries_pageinfo);
      this.refresh();
    },
    refresh() {
      if (this.one_off_listoffset) {
        listService.getlistentries(this.$route.params.listid, this.page,
          this.pageSize, this.one_off_listoffset);
        this.one_off_listoffset = 0;
      } else {
        listService.getlistentries(this.$route.params.listid, this.page,
          this.pageSize, 0);
      }
      //
      //  store.state.lists.listentries_pageinfo.total_pages
      // listService.getlist($route.params.listid);
      this.rerenderCount += 1;
    },
    BulkCancel() {
      $('#bulkModal').modal('hide');
      this.bulkprocessing = false;
    },
    BulkExport() {
      const listid = this.$route.params.listid;
      const thisurl = `/api/v1/lists/${listid}/entries?format=txt`;
      const axiosOptions = {
        timeout: 60000,
        headers: { 'X-Auth-Token': localStorage.getItem('jwt') },
        maxRedirects: 0,
        responseType: 'arraybuffer',
        withCredentials: false,
      };
      Vue.$http.get(thisurl, axiosOptions)
        .then((response) => {
          const blob = new Blob([response.data], { type: 'text/plain' });
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = `export-${listid}.txt`;
          link.click();
        })
        .catch((error) => {
          this.errmsg = error;
        });
        // .catch((error) => {
        //   // console.log(error);
        // });
    },
    BulkProcess(bulktype) {
      const badhttps = /https:\/\/.*\/.+/g;
      // console.log('Doing bulk import');
      // console.log(this.bulkurls);
      const lines = this.bulkurls.split('\n');

      for (let i = 0; i < lines.length; i += 1) {
        if (badhttps.test(lines[i])) {
          this.errBulkmsg = `The HTTPS entry ${lines[i]} cannot contain a path`;
          return;
        }
      }
      this.errBulkmsg = '';

      const thisvm = this;
      const closefunc = function closefunc() {
        // console.log('close function called');
        // console.log(result);
        // outervm.bulkprocessing = false;
        thisvm.bulkprocessing = false;
        $('#bulkModal').modal('hide');
      };

      thisvm.bulkprocessing = true;
      // closefunc(thisvm);
      // console.log(bulktype);
      if (bulktype === 'replace') {
        listService.putbulklist(this.$route.params.listid, lines, 'replace', closefunc);
      } else if (bulktype === 'delete') {
        listService.putbulklist(this.$route.params.listid, lines, 'delete', closefunc);
      } else {
        listService.putbulklist(this.$route.params.listid, lines, 'add', closefunc);
      }
      // OLD METHOD:
      // listService.putbulklist(this.$route.params.listid, lines, 'replace');
    },
    ImportOneURL() {
      const badhttps = /https:\/\/.*\/.+/g;
      if (badhttps.test(this.oneurl)) {
        this.errOnemsg = 'An HTTPS entry cannot contain a path';
        return;
      }
      this.errOnemsg = '';
      $('#addModal').modal('hide');
      this.addModalShown = false;
      const lines = [this.oneurl];
      listService.putbulklist(this.$route.params.listid, lines, 'add');
    },
    clickokdomain(thisindex, thisobj) {
      // console.log(thisobj);
      const newobj = {
        url_id: '8e125491c1642b9f',
        list_id: 760847632,
        list_name: 'act-reg',
        domain: 'safe2.com',
        path: '/path',
        description: 'safe things',
        enabled: true,
        not_used1: thisobj,
      };
      // this.editing[thisindex] = false;
      // console.log(thisindex);
      // console.log(this);
      // console.log(store.state.lists.listentries[thisindex]);
      // beforeObj = store.state.lists.listentries[thisindex];
      // listService.editlistentry(store.state.lists.listentries[thisindex]);
      listService.editlistentry(newobj);
      // this.rerenderCount += 1;
    },
    clickcanceldomain(thisindex) {
      this.editing[thisindex] = false;
      this.rerenderCount += 1;
    },
    clickdeletedomain(listobj) {
      // listService.dellistentry(listobj.list_id, listobj.url_id).then(function () {
      //   this.refresh();
      // });
      listService.dellistentry(listobj.list_id, listobj.url_id);
      // setTimeout(this.refresh, 500);
    },
    clickeditdomain(thisindex) {
      this.editing[thisindex] = true;
      this.rerenderCount += 1;
    },
  },
  beforeMount() {
    this.editing = [];
    // console.log('lets go load list id:');
    // console.log(this.$route.params.listid);
    listService.getlist(this.$route.params.listid);
    if (this.$route.params.skip_to_id) {
      this.one_off_listoffset = this.$route.params.skip_to_id;
      this.highlight_id = this.$route.params.skip_to_id;
    } else {
      this.highlight_id = '';
    }
    this.refresh();
    // listService.getlistentries(this.$route.params.listid, this.page, this.pageSize);
  },
  components: {
    VLayout: require('layouts/default/default.vue'),
    VPanel: require('components/panel/panel.vue'),
  },
};

</script>
<style>
tr.highlightentry {
  background-color: #bbeebb;
}
button.btn-edit {
  color: #003faa;
}
button.btn-delete {
  color: #aa0000;
}
td.green {
  color: #00aa00;
}
td.red {
  color: #aa0000;
}
.pagination li.activepage {
  margin: 10px;
}
</style>



// WEBPACK FOOTER //
// index.vue?43001ec2